import React, { Component } from "react";
import { HashRouter as Router,Route} from 'react-router-dom';
import Back from "./components/Back";
import Login from "./components/Login";
import './assets/css/base.css';


class App extends Component {

  state = {
    collapsed: false,
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    return (
      <Router> 
        <div className="app">
        <Route exact path="/" component={Login}/>
        <Route path="/toLogin" component={Login}/> 
        <Route path="/login/:id" component={Back}/>
        <Route path="/news" component={Back}/>
        <Route path="/pcontent" component={Back}/>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js